import * as THREE from 'three'
import { MathUtils } from 'three'
import { useEffect, useRef, useState } from 'react'
import { Canvas, useFrame } from '@react-three/fiber'
import { OrbitControls } from '@react-three/drei'
import * as Tone from 'tone'
import inst from "./inst"
import { Instances, Instance } from '@react-three/drei'
import anime from 'animejs/lib/anime.es.js';

let hit = 0;
let getInst = () => {
  hit++;
  return (hit % 2 === 0) ? inst.synthL : inst.synthR
}
let lerp = MathUtils.lerp


let getRand = (arr) => arr[Math.floor(Math.random() * arr.length)]
let notes = ["C", "D", "F", "G"]
let octaves = [0, 1, 2, 3, 4, 5, 6, 7, 8]
let allNotes = new Array(notes.length * octaves.length).fill().fill().map((val, i) => {
  return notes[i % notes.length] + octaves[Math.floor(i / notes.length)]
})
let durs = [0.1, 0.2, 0.4, 0.2, 0.3, 0.2, 0.5]
let octaveOffset = 1;
let offsets = [1,2,3,4]

function Sequence({ updated, length, ready, index, y = 4000, space = 1, width = 0.07, height = 0.05, pull, max, min, scale, ...props }) {
  const ref = useRef()
  const ref2 = useRef()
  const ref3 = useRef()
  const ref4 = useRef()
  let time = 0;
  let dur = 0
  let durMult = getRand([0.2, 0.25, 0.3, 0.4])

  let data = Array.from({ length }, (v, i) => {
    let note = allNotes[i];
    let frac = 0.48 - (i / length)
    let size = 0.3
    let pos = {
      x: Math.cos(frac * Math.PI) * size,
      y: Math.sin(frac * Math.PI) * size,
      z: 0
    }
    dur = getRand(durs) * durMult;
    time += dur
    let velocity = dur - (Math.random() * dur * 2) + 0.1
    let scale = 1
    return { time, note, i, pos, dur, currPos: { x: 0, y: 0, z: 0 }, velocity, scale, currScale: 1, durMult }
  });
  let loopEnd = time + dur
  const part = new Tone.Part(((time, val) => {
    if (!val.i) {
      mut.reverse = !mut.reverse
    }
    let s = getInst();
    let currI = !mut.reverse ? val.i : (length - 1) - val.i
    s.triggerAttackRelease(data[currI].note[0] + (parseInt(data[currI].note[1]) + octaveOffset), val.dur * 4, time, val.velocity);
    data[currI].scale = 3
    anime({
      targets: data[currI],
      scale: 1,
      duration: loopEnd * 4000
    })
    let chance = 1 - (length * 0.01)
    console.log(chance)
    if (!val.i && (Math.random() > chance)) {
      octaveOffset = getRand(offsets)
    }

  }), data);

  useEffect(() => {
    if (ready) {
      part.start();
    }
    return () => part.stop()
  }, [ready, updated])
  part.loop = true;
  part.loopStart = 0;
  part.loopEnd = loopEnd;
  let spinSpeed = 0.005
  useFrame((state) => {
    ref.current.rotation.set(0,ref.current.rotation.y + (rewind ? spinSpeed : -spinSpeed),0)
  })
  let sphere = new THREE.SphereBufferGeometry(width * 0.2, 16,16)
  let box = new THREE.BoxBufferGeometry(width * 0.4, width * 1.6, width * 0.1)
  let box2 = new THREE.BoxBufferGeometry(width * 2, width * 0.1, width * 0.2)
  box2.rotateX(Math.PI*0.5)
  let cone = new THREE.ConeBufferGeometry(width * 0.5, width * 1.5, 32, 32)
  let torus = new THREE.TorusBufferGeometry(width * 0.5, width * 0.1, 32, 32)
  let octa = new THREE.OctahedronBufferGeometry(width * 0.3)
  octa.scale(3.5,1,1)

  let speed1 = 0.005 + Math.random() * 0.02
  let base = '#aaa'
  let red = '#888'
  let bigger = Math.random() > 0.5
  let geo = getRand([octa, box2,sphere])
  let len = 40
  return (
    <>
      <Instances ref={ref} {...props} limit={2000} geometry={geo} position={[0,0,0]}>
        <meshStandardMaterial roughness={0} emissive={'green'} color={getRand([base, base, base, red])} />
        {new Array(len).fill().map((a, j) => (
          <group rotation={[0, Math.PI * 2 * j / len, 0]}>
            {data.map((curr, i) => (
              <>
                <Note key={1} i={i} data={data} size={0.1} space={0} speed={0.008} pull={pull} min={min} scale={scale} />
              </>
            ))}
          </group>
        ))}
      </Instances>
    </>
  )
}


function Note({ i, size, data, pull, min, scale, speed }) {
  const ref = useRef()
  useFrame((state) => {
    let t = state.clock.getElapsedTime()
    let lerpScale = lerp(
      data[i].currScale,
      (data[i].scale) + ((4-octaveOffset) * 0.5) * scale
      , speed
    )
    data[i].currScale = lerpScale;

    ref.current.scale.setScalar(lerpScale * size * mut.zoom2)

    let col = [0, 0, data[0].scale * 0.5]
    ref.current.color.setHSL(...col)
    let x = data[i].currPos.x = lerp(
      data[i].currPos.x,
      data[i].pos.x + (lerpScale - 1) * (0.02 * octaveOffset) * pull,
      speed)
      
    let y = data[i].currPos.y = lerp(
      data[i].currPos.y,
      Math.min(Math.max(-min, data[i].pos.y + (lerpScale - 1) * (0.06 * octaveOffset) * pull),min),
      speed)

    ref.current.position.set(
      x * mut.zoom,
      y * mut.zoom,
      data[i].pos.z * mut.zoom
    )
  })
  return (
    <>
      <Instance ref={ref} />
    </>
  )
}
let canSpawn = true;
let mut = { zoom: 1, zoom2: 1, rot: 0, rot2: 0, rot3: 0, reverse: false };
let easing = 'easeInQuart'
let easing2 = 'easeOutQuart'
let easing3 = 'easeInOutQuart'
let duration = 1000
let first = false
let rewind = false
export default function App() {

  const [ready, set] = useState(false)
  const [updated, setUpdated] = useState(false)
  const [length, setLength] = useState(28)
  const click = () => {
    Tone.Transport.start();
    Tone.context.resume();

    if (!first) {
      duration = 400
      first = true
    }
    if (canSpawn) {
      anime({
        targets: mut,
        zoom: 0,
        zoom2: 0,
        duration,
        easing,
      })
      setTimeout(() => {
        setLength(Math.floor(Math.random() * 18) + 10)
        setUpdated(!updated)
        set(true)
        canSpawn = false
        rewind = Math.random() > 0.5 ? true : false
        octaveOffset = getRand(offsets)
        setTimeout(() => {
          anime({
            targets: mut,
            zoom: 1,
            zoom2: 1,
            duration,
            easing: easing2,
          })
        }, 50)
      }, duration + 50)
      let val = 6000;
      let time = (duration * 2) / 1000;
      inst.filterL.frequency.rampTo(val, time * 0.5);
      inst.filterR.frequency.rampTo(val, time * 0.5)
      setTimeout(() => {
        inst.filterL.frequency.rampTo(inst.defaultFreq, time);
        inst.filterR.frequency.rampTo(inst.defaultFreq, time)

      }, time * 1000)
      anime({
        targets: mut,
        rot: mut.rot + getRand([1]) * getRand([1, -1]),
        duration: duration * 4,
        easing: easing3,
        complete: function (anim) {
          canSpawn = true
        }
      })

    }
  }
  return (
    <div className="fullscreen" onMouseDown={() => { click() }}>
      <Canvas shadows dpr={[1, 2]} camera={{ position: [0, 1.2, 1.3], fov: 45 }}>
        <OrbitControls autoRotate />
        <color attach="background" args={['#000']} />
        <fog attach="fog" args={['red', 60, 110]} />
        <ambientLight intensity={1.5} />
        <pointLight position={[100, 10, -50]} intensity={40} castShadow color={"blue"} />
        <pointLight position={[100, 10, 50]} intensity={40} castShadow color={"red"} />
        <Sequence updated={updated} index={1} ready={ready} length={length} pull={(Math.random()*1.5)-0.75} min={(Math.random()*getRand([0.3,0.5,1.5])) + 0.02} scale={(Math.random()*2) + 0.1} />
      </Canvas>
    </div>
  )
}

console.log('%c🌱🌱 @ramioso 2021-10-11 🌱🌱 ', 'color: orange');